import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Chip from "@mui/material/Chip";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import CheckIcon from "@mui/icons-material/Check";
import { dateTimeFormat } from "../../util/DateUtil";
import { getPrazoStatus } from "./TarefaList";

const Info = ({ label, value }) => (
  <Grid size={{ xs: 12, sm: 6 }}>
    <Typography variant="caption" color="text.secondary" component="div">
      {label}
    </Typography>
    <Typography variant="body2">{value || "--"}</Typography>
  </Grid>
);

const TarefaProfile = ({ tarefa, handleFinalizar, isLoadingAction = false }) => {
  const status = getPrazoStatus(tarefa);

  return (
    <Stack spacing={2.5}>
      <Box>
        <Typography variant="body1" sx={{ whiteSpace: "pre-line", overflowWrap: "anywhere" }}>
          {tarefa.descricao}
        </Typography>
        {status && <Chip size="small" variant="outlined" color={status.color} label={status.label} sx={{ mt: 1 }} />}
      </Box>

      <Grid container spacing={2}>
        <Info label="Atribuída por" value={tarefa.usuarioPor?.nome} />
        <Info label="Atribuída para" value={tarefa.usuarioPara?.nome} />
        <Info label="Criada em" value={dateTimeFormat(tarefa.dataHora)} />
        <Info label="Prazo" value={tarefa.possuiPrazo ? dateTimeFormat(tarefa.dataHoraPrazo) : "Sem prazo"} />
        {tarefa.finalizado && <Info label="Finalizada em" value={dateTimeFormat(tarefa.dataHoraFinalizado)} />}
      </Grid>

      {!tarefa.finalizado && (
        <Box>
          <Button
            variant="contained"
            color="success"
            startIcon={<CheckIcon />}
            disabled={isLoadingAction}
            onClick={() => handleFinalizar(tarefa.codigo)}
          >
            Finalizar
          </Button>
        </Box>
      )}
    </Stack>
  );
};

export default TarefaProfile;
